<template>
  <div class="menu">
    <div class="menu-item" @click="goNext('help')">
      <div class="menu-icon">
        <img src="../images/help/info.png" alt="도움말 아이콘">
      </div>
      <div class="menu-title">
        <span>도움말</span>
      </div>
    </div>
    <div class="menu-item" @click="goNext('privacy')">
      <div class="menu-icon">
        <img src="../images/help/user.png" alt="개인정보 이용약관 아이콘">
      </div>
      <div class="menu-title"><span>개인정보 이용약관</span></div>
    </div>
    <div class="menu-item" @click="goNext('terms')">
      <div class="menu-icon">
        <img src="../images/help/terms.png" alt="서비스 이용약관 아이콘">
      </div>
      <div class="menu-title"><span>서비스 이용약관</span></div>
    </div>
    <div class="menu-item" @click="goNext('license')">
      <div class="menu-icon"><img src="../images/help/opensource.png" alt="오픈소스 라이센스 아이콘"></div>
      <div class="menu-title"><span>오픈소스 라이센스</span></div>
    </div>
  </div>  
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'appHelp',
  data() {
    return {
    }
  },
  created() {
    this.saveView('')
    this.savePosition('appHelp')
    this.saveIsApp(true)
  },
  methods: {
    ...mapActions({ 
      saveView: 'session/save_exerciseView',
      savePosition: 'session/save_position',
      saveIsApp: 'session/save_isApp'      
    }),
    goNext(where) {
      this.$router.push({ name: where + ''})
    }
  }
}
</script>
<style scoped>
  .menu {
    padding-top: 30px;
    padding-left: 20px;
  }
  .menu-item {
    display: flex;
    padding: 20px 0px;
  }
  .menu-icon {
    width: 50px;
    padding: 10px 10px;
    align-self: center;
    text-align: center;
  }
  .menu-title {
    align-self: center;
    padding: 5px 10px;
  }
  .menu-title span {
    font-size: 1.2rem;
    font-weight: 500;
  }
</style>

